import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { useIsMobileDimension } from '@beef/ui-kit';
import { useComponentSize } from '@carnica/utils/hooks';
import { useEffect, useState } from 'react';
import { selectIsFiltersVisible } from "../../../../../entities/filters/model";
import { useSessionState } from "../../../../../shared/lib";
import { useAppSelector } from "../../../../../shared/model";
export var useFormHeight = function useFormHeight(inputRef) {
  var isMobile = useIsMobileDimension();
  var startHeightForm = isMobile ? 80 : 72;
  var PADDING_SIZE_INPUT = 24;
  var PADDING_SIZE_FORM = isMobile ? 36 : 28;
  var _useState = useState(startHeightForm),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  var _useComponentSize = useComponentSize(inputRef),
    inputHeight = _useComponentSize.height;
  var _useSessionState = useSessionState('chatCurrentMessage', {
      // Необходимо так как хук по умолчанию конвертирует данные в конкретный тип (если текст число то результат хука выйдет по типам тоже число)
      storeToState: function storeToState(val) {
        return val;
      },
      stateToStore: function stateToStore(val) {
        return val || '';
      }
    }),
    _useSessionState2 = _slicedToArray(_useSessionState, 1),
    message = _useSessionState2[0];
  var hidden = useAppSelector(selectIsFiltersVisible);

  // Динамически обновляем высоту формы
  // eslint-disable-next-line consistent-return
  useEffect(function () {
    if (inputRef.current) {
      var observer = new ResizeObserver(function (entries) {
        // eslint-disable-next-line no-restricted-syntax
        var _iterator = _createForOfIteratorHelper(entries),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var entry = _step.value;
            var newHeightForm = entry.contentRect.height + PADDING_SIZE_INPUT + PADDING_SIZE_FORM;
            setHeight(newHeightForm);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      observer.observe(inputRef.current);

      // Cleanup function
      return function () {
        observer.disconnect();
      };
    }
  }, []);
  useEffect(function () {
    if (hidden && !message) {
      setHeight(0);
    }
  }, [inputHeight, hidden]);
  return height;
};